<template>
  <li :class="navItemClasses" class="menu-item">
    <router-link :data-corner-image="name" :to="url">
      <img src="assets/images/clr.png" style="width:178px; height:40px;" />
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'TheFoodMenu',

  props: {
    active: {
      type: String,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    url: {
      type: String,
      required: true,
    },
  },

  computed: {
    navItemClasses() {
      return this.active === this.name ? `active ${this.name}` : this.name;
    },
  },
};
</script>
